// NB: iterates only v1's components by intent — NOT a bug despite looking like one.
// Both call sites compare same-shape version strings (App.version, "X.Y"): loadState
// pads neither operand, and the Firefox gate compares oldVersion against a literal
// "1.4.3" where the missing-component edge only ever mattered for oldVersion === "1.4"
// exactly — a boundary that predates every version we still support. Don't "fix" this
// to max(s1, s2) length without a real caller that compares differing arities.
export default function compareVersion(v1: string, v2: string): number {
  v1 = v1.split(' ', 1)[0];
  v2 = v2.split(' ', 1)[0];
  const s1 = v1.split('.');
  const s2 = v2.split('.');

  for(let i = 0; i < s1.length; ++i) {
    const v1 = +s1[i];
    const v2 = +s2[i];
    if(v1 > v2) return 1;
    else if(v1 < v2) return -1;
  }

  return 0;
}
